<script lang="ts">
  import QuickOrderListGroup from "@retailer/svelte/Shared/QuickOrderList/QuickOrderListGroup.svelte";
  import type { PageData } from "@shared/types/PageData";
  import type {
    QuickOrderListDetail,
    QuickOrderListIndex,
    QuickOrderListFilters,
  } from "@shared/types/QuickOrderList";
  import type { RetailerType } from "@shared/types/Retailer";
  import retailerContext from "@modern/services/retailer_context";

  export let list: QuickOrderListDetail;
  export let lists: QuickOrderListIndex[];
  export let callbacks;
  export let filters: QuickOrderListFilters;
  export let page: PageData;
  export let filter;
  export let showLoading: boolean = false;

  let retailer: RetailerType = retailerContext.get();

  callbacks.touchList = function () {
    list = list;
  };

  let selectFilter = function (event) {
    let { direction, listId, sort } = event.detail.filters;
    let savedSort = JSON.stringify({ sort, direction });
    if (listId) window.localStorage.setItem(`SortPref-${listId}`, savedSort);
    filter(event);
  };
  $: {
    page = page;
    list = list;
  }
</script>

<div class="fizz-styles">
  <QuickOrderListGroup
    {list}
    listType={list.list_type}
    {lists}
    {page}
    {filters}
    {retailer}
    on:selectFilter={selectFilter}
    {callbacks}
    {showLoading}
  />
</div>
